import type { CloudMaterial } from '../../features/materials/materialsSlice';
import { MaterialPreviewModal } from './shared/MaterialPreviewModal';
import { useCloudMaterials } from '../../features/materials/hooks';

type Props = {
  material: CloudMaterial;
  onClose: () => void;
  onNavigate?: (direction: 1 | -1) => void;
  /** 削除成功後の遷移先。指定時は onClose の代わりに呼ばれる (親が次の素材へ送る) */
  onDeleted?: (materialId: string) => void;
  onRefresh?: (material: CloudMaterial | null) => void;
  showAddToSelectionButton?: boolean;
};

export function CloudMaterialsModal({ material, onClose, onNavigate, onDeleted, onRefresh, showAddToSelectionButton = false }: Props) {
  const cloudQuery = useCloudMaterials();

  return (
    <MaterialPreviewModal
      material={material}
      materialId={material.id}
      onClose={onClose}
      onNavigate={onNavigate}
      onDeleted={onDeleted}
      showEditControls={true}
      showAddToSelectionButton={showAddToSelectionButton}
      isTemporary={false}
      onRequestRefresh={async (materialId) => {
        try {
          const result = await cloudQuery.refetch({ throwOnError: false, cancelRefetch: false });
          const allItems = result.data?.pages.flatMap(page => page.items) ?? [];
          const updatedMaterial = allItems.find((item) => item.id === materialId) ?? null;
          onRefresh?.(updatedMaterial);
        } catch (error) {
          console.error('クラウド素材の再取得に失敗しました:', error);
          const allItems = cloudQuery.data?.pages.flatMap(page => page.items) ?? [];
          const fallbackMaterial = allItems.find((item) => item.id === materialId) ?? null;
          onRefresh?.(fallbackMaterial);
        }
      }}
    />
  );
}
